import { DashboardCard } from "@dashboard/components/Card";
import { Box, Checkbox, Text, Textarea } from "@saleor/macaw-ui-next";
import { useIntl } from "react-intl";

import { platformMessages } from "./messages";

interface LoginRestrictionsCardProps {
  loginHoursOnly: boolean;
  allowedIpRanges: string;
  disabled: boolean;
  error?: string;
  onChange: (name: "loginHoursOnly" | "allowedIpRanges", value: boolean | string) => void;
}

export const LoginRestrictionsCard = ({
  loginHoursOnly,
  allowedIpRanges,
  disabled,
  error,
  onChange,
}: LoginRestrictionsCardProps) => {
  const intl = useIntl();

  return (
    <DashboardCard>
      <DashboardCard.Header>
        <DashboardCard.Title>
          {intl.formatMessage(platformMessages.restrictionsTitle)}
        </DashboardCard.Title>
      </DashboardCard.Header>
      <DashboardCard.Content>
        <Text as="p" size={3} marginBottom={4}>
          {intl.formatMessage(platformMessages.restrictionsDescription)}
        </Text>
        <Box display="flex" flexDirection="column" gap={4}>
          <Checkbox
            data-test-id="login-hours-only-checkbox"
            checked={loginHoursOnly}
            disabled={disabled}
            onCheckedChange={value => onChange("loginHoursOnly", !!value)}
          >
            <Text>{intl.formatMessage(platformMessages.hoursOnly)}</Text>
          </Checkbox>
          <Textarea
            data-test-id="login-ip-ranges-input"
            rows={4}
            label={intl.formatMessage(platformMessages.ipRanges)}
            helperText={error ?? intl.formatMessage(platformMessages.ipRangesHelp)}
            error={!!error}
            value={allowedIpRanges}
            disabled={disabled}
            onChange={event => onChange("allowedIpRanges", event.target.value)}
          />
        </Box>
      </DashboardCard.Content>
    </DashboardCard>
  );
};
